"use client";

import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["disabled"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import e from "react";
import { useId as f } from '../../hooks/use-id.js';
import { useSlot as P } from '../../hooks/use-slot.js';
import { DisabledProvider as y, useDisabled as u } from '../../internal/disabled.js';
import { FormFieldsProvider as D } from '../../internal/form-fields.js';
import { IdProvider as v } from '../../internal/id.js';
import { forwardRefWithAs as b, useRender as E } from '../../utils/render.js';
import { useDescriptions as A } from '../description/description.js';
import { useLabels as L } from '../label/label.js';
let _ = "div";
function c(d, l) {
  let t = "headlessui-control-".concat(f()),
    [p, s] = L(),
    [n, a] = A(),
    m = u(),
    {
      disabled: r = m || !1
    } = d,
    o = _objectWithoutProperties(d, _excluded),
    i = P({
      disabled: r
    }),
    F = {
      ref: l,
      disabled: r || void 0,
      "aria-disabled": r || void 0
    },
    T = E();
  return e.createElement(y, {
    value: r
  }, e.createElement(s, {
    value: p
  }, e.createElement(a, {
    value: n
  }, e.createElement(v, {
    id: t
  }, T({
    ourProps: F,
    theirProps: _objectSpread(_objectSpread({}, o), {}, {
      children: e.createElement(D, null, typeof o.children == "function" ? o.children(i) : o.children)
    }),
    slot: i,
    defaultTag: _,
    name: "Field"
  })))));
}
let W = b(c);
export { W as Field };